<template>
    <div>
        <div class="mb-32 d-flex flex-column flex-md-row align-items-md-center justify-content-between">

            <button class="mt-3 mb-3 mt-md-0 mb-md-0 button btn-small btn-v1" v-b-modal.modalCalendar>
                <span v-if="store.rate.count == 0">Выбрать</span>
                <span v-else>Изменить</span>
                период аренды
            </button>

            <div class="h5 d-flex align-items-end mb-0">
                <div class="pr-2">Выбрано:</div>
                <div v-if="store.rate.value == 1 && store.rate.count != 0">
                    {{store.rate.count}}
                    <span v-if="store.rate.count > 1">часа</span>
                    <span v-else>час</span>
                </div>
                <div v-if="store.rate.value == 2 && store.rate.count != 0" class="d-flex">
                    <div class="pr-1">{{store.rate.count}} сут.</div>
                    <div v-if="store.state.timeStart.HH && store.state.timeEnd.HH && store.state.timeStart.mm && store.state.timeEnd.mm">
                        ({{displayDates}})
                    </div>
                </div>
                <div v-if="store.rate.count == 0" class="font-500">0 сут.</div>
            </div>

        </div>

        <div class="item-table mb-12 promo-code-basket" v-if="order.state.step != 1">
            <hr>
                <div class="title-4 text-uppercase mb-24 font-700">Прокомоды</div>
                <div class="row col-sm-12" v-if="promoCodeActivatedNames.length > 0">
                    <label class="color-text-label">Активированные промокоды: {{ promoCodeActivatedNames }}</label>
                </div>
                <div class="mb-32 d-flex flex-column flex-md-row align-items-md-center justify-content-between">

                        <div class="d-md-flex align-items-center mb-3 mb-md-0 col-md-10 col-12">
                            <input class="img-fluid" type="text" v-model="promoCodeLine">
                        </div>
                    <button @click="inputPromoCodeLine()" class="button btn-small"> Ввести</button>
                </div>
<!--                    <div class="multiselect-nova">-->
<!--                        <div class="input-box w-100-multiselect__content-wrapper">-->
<!--                            <multiselect v-model="promoCodes"-->
<!--                                         placeholder=""-->
<!--                                         :multiple="true"-->
<!--                                         :options="promoCodesAll"-->
<!--                                         track-by="name"-->
<!--                                         label="name"-->
<!--                                         deselectLabel=""-->
<!--                                         selectedLabel=""-->
<!--                                         selectGroupLabel=""-->
<!--                                         selectLabel=""-->

<!--                                         @open="focusedPromoCodes = true"-->
<!--                                         @close="focusedPromoCodes = false"-->
<!--                                         @input="updatePromoCodes"-->
<!--                                         @new-value="createValue"-->
<!--                            >-->
<!--                                <span class="label" :class="{'active': promoCodes || focusedPromoCodes}" slot="caret">Допустимые промокоды</span>-->
<!--                                <span slot="noResult">-->
<!--                                                  Такого промокода не существует.-->
<!--                                                </span>-->
<!--                            </multiselect>-->
<!--                        </div>-->
<!--                    </div>-->

            <hr>
        </div>

        <div class="item-table mb-12">
            <div class="item-table__header">
                <div>Фото</div>
                <div>Название</div>
                <div>Цена за сутки</div>
                <div class="d-none d-xl-block">Скидка</div>
                <div>Кол-во</div>
                <div>Цена</div>
                <div>Итого скидка</div>
                <div>Цена со скидкой</div>
            </div>

            <div v-for="item in items">
                <basket-item :item="item" @update="updateData()"></basket-item>
            </div>
        </div>

        <div class="d-flex justify-content-between flex-wrap mb-24">
            <div class="h5 mb-2">Продуктов в корзине: <span v-if="store.state.basket_count">{{store.state.basket_count}}</span></div>

            <div @click="removeItems()" v-if="order.state.step == 1" class="h5 mb-2 icon-link cursor-pointer remove_items">
                Очистить корзину</div>
        </div>


        <modal-calendar></modal-calendar>

    </div>
</template>

<script>
    import store from '../../../../services/data';
    import order from '../../../../services/order';
    import moment from 'moment';
    import Multiselect from 'vue-multiselect';

    export default {
        components: {Multiselect},
        data() {
            return {
                promoCodeLine: '',
                focusedPromoCodes: false,
                promoCodes: [],
                promoCodeActivatedNames: '',
                promoCodesAll: [],
                items: null,
                store: store,
                order: order,
            }
        },

        mounted() {
            this.store.updateBasketWithPrice();
            this.items = this.store.state.basket_items;
            if (order.state.step != 1) {
                this.getPromoCodes();
            }
        },

        methods: {
            showSwal(iconType, text) {
                Swal.fire({
                    icon: iconType,
                    title: 'Внимание!',
                    html: text,
                    confirmButtonText: 'Ок',
                });
            },
            inputPromoCodeLine() {
                if (this.promoCodeLine == '') {
                    this.showSwal('warning', 'Введите промокод!');
                } else if (this.promoCodesAll.length == 0 && this.promoCodes.length == 0) {
                    this.showSwal('warning', 'Для данного набора товаров нету допустимых промокодов!');
                } else if (this.promoCodesAll.findIndex(item => item.name == this.promoCodeLine) == -1) {
                    this.showSwal('warning', 'Данный промокод не допустим для активации!');
                } else if (this.promoCodes.length > 0 && this.promoCodes.findIndex(item => item.multiple_use == 0 && item.name == this.promoCodeLine) != -1) {
                    this.showSwal('warning', 'Вы уже активировали данный промокод!');
                }
                else {
                    this.promoCodes.push(this.promoCodesAll.find(item => { return item.name == this.promoCodeLine }));
                    this.store.removeItemLocaleStorage('promoCodes');
                    this.store.setItemlocalStorage('promoCodes',  this.promoCodes);
                    this.store.updateBasketWithPrice();
                    this.promoCodeActivatedNames += this.promoCodeLine + ' ';
                    this.promoCodeLine = '';
                    this.$emit('update', true);
                    this.showSwal('success', 'Промокод был успешно активирован!');
                }
            },
            updatePromoCodes() {
                this.store.removeItemLocaleStorage('promoCodes');
                this.store.setItemlocalStorage('promoCodes',  this.promoCodes);
                this.store.updateBasketWithPrice();
                this.$emit('update', true);
            },
            getPromoCodes() {
                this.store.removeItemLocaleStorage('dependences');
                let promoCodes = JSON.parse(this.store.getItemlocalStorage('promoCodes'));
                this.store.removeItemLocaleStorage('promoCodes');
                let url = '/api/get-promo-codes';
                const options = {
                    headers: {Authorization: "Bearer " + localStorage.getItem('token')},
                };

                let promoCode = null;
                let data = { products: this.items };
                axios.post(url, data, options)
                    .then(response => {
                        if (response.status == 200) {
                            this.promoCodesAll = response.data.availeblePromoCodes;
                            if (this.promoCodesAll != undefined && this.promoCodesAll != null && this.promoCodesAll.length > 0
                                && promoCodes != undefined && promoCodes != null && promoCodes.length > 0) {
                                this.promoCodesAll.forEach(promoCodesAllItem => {
                                    promoCode = promoCodes.find(promoCodesItem => {
                                        return promoCodesAllItem.id == promoCodesItem.id;
                                    });
                                    if (promoCode != null) {
                                        this.promoCodes.push(promoCode);
                                        this.promoCodeActivatedNames += promoCode.name + ' ';
                                    }
                                })
                            }
                            this.store.setItemlocalStorage('promoCodes', this.promoCodes);
                            this.store.setItemlocalStorage('dependences', response.data.dependences);
                            this.store.updateBasketWithPrice();
                        }
                    })
            },
            updateData() {
                this.items = null;
                this.store.state.basket_count = null;
                this.$emit('update', true);
            },
            removeItems() {
                Swal.fire({
                    icon: 'warning',
                    title: 'Внимание!',
                    html: 'Вы уверены, что хотите удалить все товары из корзины?',
                    confirmButtonText: 'Удалить',
                    showCancelButton: true,
                    cancelButtonText: 'Нет, случайно нажал'
                }).then((result) => {
                    /* Read more about isConfirmed, isDenied below */
                    if (result.isConfirmed) {
                        this.store.removeItemLocaleStorage('chosen-products');
                        this.items = null;
                        this.store.state.basket_count = null;
                        this.$emit('update', true);
                        this.$router.push({path: '/catalog'});
                    }
                })
            },
        },

        computed: {
            displayDates() {
                const timeStart = {hour: this.store.state.timeStart.HH, minute: this.store.state.timeStart.mm, second: 0, millisecond: 0};
                const timeEnd = {hour: this.store.state.timeEnd.HH, minute: this.store.state.timeEnd.mm, second: 0, millisecond: 0};
                const from = moment(this.store.state.dates.start).set(timeStart).format('DD.MM.YY');
                const to = moment(this.store.state.dates.end).set(timeEnd).format('DD.MM.YY');
                if(this.store.state.dates.start == null || this.store.state.dates.end == null) {
                    return 'Выберите дату...';
                }
                else if (timeStart.hour == null || timeEnd.hour == null || timeStart.minute == null || timeEnd.minute == null) {
                    return 'Выберите время...';
                }else {
                    return `${from} - ${to}`;
                }
            },
        },

        watch: {
            displayDates() {
                this.store.getItemBasketData();
            },
            'store.state.basket_items'() {
                this.items = this.store.state.basket_items;
                this.store.state.basket_count = this.items.length
            }
        },
    }
</script>
